"use client";

import { ReactNode } from "react";
import Link from "next/link";
import { useUser } from "@/hooks/use-async";

export function Navigation() {
  const { user, logout } = useUser();

  return (
    <nav className="bg-white nc-shadow-lg">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
        <Link href="/" className="text-2xl font-bold text-blue-600">
          Boutika
        </Link>

        <div className="flex gap-4 items-center">
          <Link href="/products" className="hover:text-blue-600">
            Products
          </Link>

          {user ? (
            <>
              <Link href="/dashboard" className="hover:text-blue-600">
                Dashboard
              </Link>
              <Link href="/wishlist" className="hover:text-blue-600">
                Wishlist
              </Link>
              <Link href="/profile" className="hover:text-blue-600">
                Profile
              </Link>
              <button
                onClick={logout}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                href="/login"
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Login
              </Link>
              <Link
                href="/register"
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

interface LayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className="max-w-6xl mx-auto px-4 py-8">{children}</main>
    </div>
  );
}
